import { useEffect, useState } from 'react'

// hook to solve rehydration issues
// see: https://www.gatsbyjs.com/docs/react-hydration/ ,
// and: https://joshwcomeau.com/react/the-perils-of-rehydration/

const useHasMounted = () => {
  const [hasMounted, setHasMounted] = useState(false)
  useEffect(() => {
    setHasMounted(true)
  }, [])
  return hasMounted
}

export default useHasMounted
